import React, { useEffect, useState } from "react";

import Header from "../../components/header";
import Footer_V2 from "../../components/footer-v2/component";
import AppButton from "../../components/button/component";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import FunnelStepTypes from "../funnel-step/types";
import { useDispatch } from "react-redux";
import { trackEvents } from "../../utils/tracking-events";
import {
  getPortalCD,
  readCookie,
  createCookie,
  deleteCookie,
} from "../../utils/helpers";
import {
  addSpacesOnCaps,
  convertToLowerCase,
  getCountryCode,
  getImage,
  InvitationStatus,
  REPORT_ROUTES,
  getCookie,
  getconfirmatationIQImage,
} from "../../utils/utility-functions";
import {
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
} from "../../utils/general-config";
import { useTranslation } from "react-i18next";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import "../../components/share-modal/component";
import ShareProfileModal from "../../components/share-modal/component";
import { CreateNewUserModel } from "../../components/model/component";
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

const ConfirmationIQ = ({
  UpdateConfimationConnect,
  funnelStep,
  GetUserByIdConnect,
  DownloadAssessmentResultConnect,
  IsGuestOrPremiumUserConnect,
  ViewAssessmentReportConnect,
  updateUserConnect,
  createGuestUserWithoutEmailConnect,
  GuestUserChangesConnect,
  GetGuestUserConnect,
  GetBillingConnect,
  saveRelationshipCompatibilityResultConnect,
  saveUserAssessmentResultMapsConnect,
  isGuestOrPremiumUserConnect,
  SubmitSurveyFeedbackConnect,
  getAssessmentConnect,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    userGUID,
    isConfirmationView,
    assessmentAttemptId,
    email,
    gender,
    assessmentId,
    countryCD: reduxCountryCD,
    currencyCD,
    assessmentMapId,
    isAuth,
    romanticCompatibilityParentUserId,
  } = funnelStep || {};

  const countryCD = getCountryCode(reduxCountryCD);
  const isRomanticCompatiblityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);
  const romanticCompatibilityTestParentUserId =
    isRomanticCompatiblityTest && romanticCompatibilityParentUserId;
  const [isParentUserGuestOrPremium, setIsParentUserGuestOrPremium] =
    useState(false);

  // const token = localStorage.getItem("jwtToken");
  // const token = getCookie("jwtToken");
  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  const [showFalsePlanModal, setShowFalsePlanModal] = useState(false);
  const [showInviteFriendModal, setShowInviteFriendModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [guestUserCount, setGuestUserCount] = useState(0);
  const [guestUserData, setGuestUserData] = useState([]);
  const [billingDetails, setBillingDetails] = useState(null);
  const [isPremiumOrGuest, setIsPremiumOrGuest] = useState(false);
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);
  const [assessmentTitle, setAssessmentTitle] = useState("");
  const cardFirstName = readCookie("iqCardFirstName") || "";
  const confirmation1 = "confirmationIQ";
  const confirmation2 = "analytics-icon";
  const confirmationImage1 = getconfirmatationIQImage(confirmation1);
  const confirmationImage2 = getconfirmatationIQImage(confirmation2);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    trackEvents("confirmationView", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
    const disableBack = () => {
      window.history.forward();
    };

    const handleOnUnload = () => null;

    setTimeout(disableBack, 0);
    window.onunload = handleOnUnload;

    // Cleanup function
    return () => {
      window.onunload = null;
    };
  }, []);

  useEffect(() => {
    const isFalsePlan = getCookie("isFalsePlan");

    if (isFalsePlan === "true") {
      setShowFalsePlanModal(true);
    }
  }, []);

  useEffect(() => {
    if (userGUID) {
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          const fullName =
            res?.firstName || res?.lastName
              ? `${res.firstName} ${res.lastName}`
              : res?.userName;

          dispatch(
            PushUserInformationToFunnelStep({
              userGUID: res.userGuid,
              email: res?.email,
              accnum: res?.accountNumber,
              uname: fullName,
            }),
          );
          // createCookie("userguid", res?.userGuid, 1);
          // createCookie("uname", fullName, 1);
          // createCookie("accnum", res?.accountNumber, 1);
        }
      });
    }
  }, [userGUID]);
  useEffect(() => {
    if (!assessmentId) return;

    const fetchAssessment = async () => {
      try {
        const response = await getAssessmentConnect(currentLocale);

        if (response) {
          const assessment = Array.isArray(response)
            ? response.find(
                (item) =>
                  item.id?.toLowerCase() === assessmentId?.toLowerCase(),
              )
            : response;

          if (assessment) {
            setAssessmentTitle(assessment.title);
          }
        }
      } catch (error) {
        console.error("Error fetching assessment:", error);
      }
    };

    fetchAssessment();
  }, [assessmentId, currentLocale, getAssessmentConnect]);

  const assessmentIDValue = assessmentId?.toLowerCase();
  const isPersonalityTest =
    assessmentIDValue === PERSONALITY_TEST_ASSESSMENT_ID;
  const queryParams = new URLSearchParams(location.search);
  const pt = queryParams.get("pt");
  const pn = queryParams.get("pn");
  const pg = isPersonalityTest === true ? queryParams.get("pg") : undefined;
  const assessmentGroup = queryParams.get("pg");
  const personalityNameEnglishCode = queryParams.get("pnes");

  const personalityImage = getImage(
    pg,
    personalityNameEnglishCode,
    true,
    gender,
  );

  useEffect(() => {
    if (isAuth) {
      // createCookie("avatarImg", personalityImage, 1);
      dispatch(
        PushUserInformationToFunnelStep({
          avatarImg: personalityImage,
        }),
      );
    }
  }, [isAuth, personalityImage]);

  useEffect(() => {
    if (!isAuth) {
      navigate(loginPath.next);
    }
  }, [isAuth]);

  const PushConfirmationViewToFunnelStep = (confirmationView) => ({
    type: FunnelStepTypes.SET_CONFIRMATION_VIEW,
    confirmationView,
  });
  useEffect(() => {
    if (
      romanticCompatibilityTestParentUserId &&
      romanticCompatibilityTestParentUserId !== null
    ) {
      isGuestOrPremiumUserConnect(romanticCompatibilityTestParentUserId).then(
        (res) => {
          if (res) {
            setIsParentUserGuestOrPremium(res?.isPremiumOrGuestUser);
          }
        },
      );
    }
  }, [romanticCompatibilityTestParentUserId]);

  useEffect(() => {
    if (!isConfirmationView && userGUID) {
      const data = {
        userGuid: userGUID,
      };
      UpdateConfimationConnect(data);
      dispatch(PushConfirmationViewToFunnelStep(true));
    }
  }, [userGUID, UpdateConfimationConnect, isConfirmationView]);

  const handleRomanticCompatibilityResultSaving = () => {
    if (
      isRomanticCompatibilityTest &&
      romanticCompatibilityTestParentUserId &&
      !isParentUserGuestOrPremium
    ) {
      saveRelationshipCompatibilityResultConnect(assessmentMapId).then(
        (res) => {
          if (!!res) {
            const resultId = res.userTraits[0]?.userAssessmentResultId;
            const payloadAssessmentResultMap = [
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: romanticCompatibilityTestParentUserId,
              },
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: userGUID,
              },
            ];
            saveUserAssessmentResultMapsConnect(
              payloadAssessmentResultMap,
            ).then((res) => {
              if (!!res) {
                const data = {
                  parentUserGuid: userGUID,
                  userGuid: romanticCompatibilityTestParentUserId,
                };
                updateUserConnect(data).then((res) => {
                  if (res) {
                    const { firstName, lastName, email } = res;
                    const guestUserPayload = {
                      id: romanticCompatibilityTestParentUserId,
                      firstName: firstName || "",
                      lastName: lastName || "",
                      emailAddress: email,
                      invitationStatus: InvitationStatus.Accepted,
                      parentId: userGUID,
                    };
                    createGuestUserWithoutEmailConnect(guestUserPayload).then(
                      (res) => {
                        if (res) {
                        }
                      },
                    );
                  }
                });
              }
            });
          }
        },
      );
    }
  };

  useEffect(() => {
    if (romanticCompatibilityTestParentUserId && !isConfirmationView) {
      handleRomanticCompatibilityResultSaving();
    }
  }, [romanticCompatibilityTestParentUserId, isConfirmationView]);

  useEffect(() => {
    createCookie("showReportFeedback", "true", 1);
  }, []);

  const isEnneagramTest = assessmentIDValue === ENNEAGRAM_TEST_ASSESSMENT_ID;
  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentIDValue) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const handleViewReport = () => {
    let reportRoute;
    if (isRomanticCompatibilityTest) {
      const romanticRoutes = REPORT_ROUTES[assessmentIDValue];
      reportRoute = romanticRoutes?.personal;
    } else {
      reportRoute = REPORT_ROUTES[assessmentIDValue];
    }
    const path = PathHelper(reportRoute, currentLocale);
    deleteCookie("iqCardFirstName");
    navigate(`${path.next}?uid=${userGUID}&aai=${assessmentAttemptId}`);
  };

  return (
    <>
      <div className="min-h-[100dvh] flex flex-col bg-[#FFF8F4]">
        <Header />

        <div className="flex-1 flex flex-col items-center px-5 py-10 md:py-12">
          <ShareProfileModal
            isOpen={showFalsePlanModal}
            onClose={() => setShowFalsePlanModal(false)}
            isFreeUpgrade={true}
            onInviteFriendsClick={() => {
              setShowFalsePlanModal(false);
              setShowInviteFriendModal(true);
            }}
          />

          <CreateNewUserModel
            isOpen={showInviteFriendModal}
            setOpen={setShowInviteFriendModal}
            parentId={userGUID}
            CreateGuestUserConnect={GuestUserChangesConnect}
            GetGuestUserConnect={GetGuestUserConnect}
            setGuestUserData={setGuestUserData}
            setGuestUserCount={setGuestUserCount}
            parentEmail={userData?.email}
            guestUserData={guestUserData}
            currentLocale={currentLocale}
            t={t}
            isPremiumOrGuest={isPremiumOrGuest}
            guestUserCount={guestUserCount}
            maxSubUserCount={billingDetails?.maxSubUserCount}
          />

          {/* Header Section */}
          <div className="w-full max-w-[700px] text-center">
            <p className="font-montserrat font-bold tracking-[2px] text-[12px] md:text-[13px] text-insightful-green uppercase">
              {t("confirmation_iq.payment")}
            </p>

            <h1 className="mt-2 font-montserrat font-bold text-[30px] md:text-[38px] leading-tight text-insightful-black">
              {t("confirmation_iq.member")}
              <br />
              🎉
            </h1>
            <p className="mx-auto max-w-[500px] font-montserrat text-[14px] md:text-[16px] leading-[1.45] text-insightful-gray">
              {t("confirmation_iq.welcome", {
                fname: cardFirstName ? ` ${cardFirstName}` : "",
              })}
            </p>
          </div>
          {/* Animation placeholder */}
          <div className="relative h-[15px] md:h-[20px] w-full max-w-[300px] overflow-hidden">
            <span
              className="absolute left-[8%] top-0 w-[9px] h-[9px] rounded-[2px] bg-[#FF8C6B] animate-ftFall"
              style={{ animationDuration: "2.4s", animationDelay: "0.1s" }}
            />

            <span
              className="absolute left-[26%] top-0 w-[8px] h-[8px] rounded-full bg-insightful-dark-orange animate-ftFall"
              style={{ animationDuration: "2.7s", animationDelay: "0.5s" }}
            />

            <span
              className="absolute left-[48%] top-0 w-[10px] h-[10px] rounded-[2px] bg-[#FFD166] animate-ftFall"
              style={{ animationDuration: "2.2s", animationDelay: "0.9s" }}
            />

            <span
              className="absolute left-[70%] top-0 w-[8px] h-[8px] rounded-full bg-insightful-green animate-ftFall"
              style={{ animationDuration: "2.6s", animationDelay: "0.3s" }}
            />

            <span
              className="absolute left-[88%] top-0 w-[9px] h-[9px] rounded-[2px] bg-[#8ECAE6] animate-ftFall"
              style={{ animationDuration: "2.5s", animationDelay: "0.7s" }}
            />
          </div>
          {/* Achievement Card */}
          <div className="w-full max-w-[300px]">
            <div className="relative overflow-hidden rounded-[20px] border border-[#F2DCD3] bg-white px-6 py-6 text-center shadow-[0_18px_35px_rgba(238,115,76,0.18)]">
              {/* shine sweep across the card, like ftShine in your reference */}
              <div className="pointer-events-none absolute top-0 left-0 h-[200%] w-[60px] bg-gradient-to-r from-transparent via-white/60 to-transparent animate-ftShine" />

              <p className="font-montserrat mb-5 font-bold tracking-[1.5px] text-[11px] text-insightful-dark-orange uppercase relative overflow-hidden after:content-[''] after:absolute after:top-0 after:-left-full after:h-full after:w-1/2 after:bg-white/50 after:skew-x-[-20deg] after:animate-ftShine">
                {t("confirmation_iq.achievement_unlocked")}
              </p>

              {/* Badge with bounce-in animation */}
              <div className="relative mx-auto w-[112px] h-[112px] animate-ftBadge">
                <img
                  src={confirmationImage1}
                  alt="Achievement"
                  className="w-full h-full object-contain"
                />

                <span className="absolute bottom-[-6px] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#FFD35C] px-3 py-[2px]">
                  <span className="font-montserrat font-bold text-[10px] text-[#4A403B]">
                    {t("confirmation_iq.level")}
                  </span>
                </span>
              </div>

              <h2 className="mt-5 font-montserrat font-bold text-[18px] text-[#302B29]">
                {t("confirmation_iq.explorer")}
              </h2>

              <p className="mt-1 font-montserrat text-[12px] leading-[1.4] text-[#817773]">
                {t("confirmation_iq.awarded")}
              </p>
            </div>
          </div>

          {/* Assessment Status */}
          <div className="mt-6 w-full max-w-[435px]">
            <div className="flex items-center justify-center rounded-[13px] border border-[#E5E1DF] bg-white px-5 py-4">
              {/* Assessment image placeholder */}

              <div className="mr-4 flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full">
                {/* assessmentImage */}
                <img
                  src={confirmationImage2}
                  alt="Report Ready"
                  className="mx-auto h-[38px] w-[38px] object-contain"
                />
              </div>

              <div className="text-left">
                <p className="font-montserrat font-bold text-[14px] text-[#302B29]">
                  {t("confirmation_iq.assessment")}
                </p>

                <p className="font-montserrat text-[11px] text-[#948B87]">
                  {t("confirmation_iq.completed")}
                </p>
              </div>
            </div>
          </div>

          {/* Personality information - functionality preserved */}
          {pn && pt && isPersonalityTest && (
            <>
              <p className="mt-4 text-[#805AED] text-lg">
                {t("dashboard.personality_type_label")} :
              </p>

              <h2 className="font-montserrat font-bold text-2xl">
                <span className="text-[#444C5E]">{pn} </span>
                <span className="font-normal text-[#805AED]">{pt}</span>
              </h2>
            </>
          )}

          {pn && pt && isEnneagramTest && (
            <>
              <p className="mt-4 text-[#805AED] text-lg">
                {t("dashboard.personality_type_message")}
              </p>

              <h2 className="font-montserrat font-bold text-2xl">
                <span className="text-[#444C5E]">{addSpacesOnCaps(pn)}</span>
              </h2>
            </>
          )}

          {/* Buttons */}
          <div className="mt-5 w-full max-w-[435px] flex flex-col gap-2.5">
            {pn && pt && (
              <AppButton
                id="confirmation-view-report"
                className="w-full h-[48px] md:h-[50px] rounded-[13px] underline bg-[#FF8568] text-white font-montserrat font-bold text-[15px] shadow-[0_8px_20px_rgba(255,133,104,0.18)] hover:bg-insightful-orange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                onClick={handleViewReport}
              >
                {t("confirmation_iq.view_report_cta_iq")} →
              </AppButton>
            )}

            <AppButton
              id="confirmation-go-to-dashboard-button"
              className="w-full h-[48px] md:h-[50px] rounded-[13px] border border-[#DDD8D5] bg-white text-[#302B29] font-montserrat font-bold text-[14px] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
              onClick={() => {
                deleteCookie("iqCardFirstName");
                navigate(dashboardPath.next);
              }}
            >
              {t("confirmation_iq.go_to_dashboard_cta_iq")}
            </AppButton>
          </div>
        </div>

        <Footer_V2 />
      </div>
    </>
  );
};

export default ConfirmationIQ;
